import { defineComponent as _defineComponent } from 'vue'
import BCXButton from '@/components/molecules/BCXButton.vue';
import BCXItemsWithPoints from '@/components/molecules/BCXItemsWithPoints.vue';
import { useMyProjects } from '@/views/my-projects/composables/useMyProjects';
import { PropType, computed } from 'vue';
import useI18n from '@/mixins/useI18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectsOfferDetailActions',
  props: {
  canPickOrReject: Boolean,
  type: {
    type: String as PropType<'made' | 'received'>,
    required: true
  },
  isOfferOpen: Boolean,
  isLoading: Boolean
},
  emits: ['profile', 'message', 'accept', 'reject', 'withdraw', 'extend-validity'],
  setup(__props, { emit }) {

const props = __props;



const { isNarrow } = useMyProjects();
const { t } = useI18n();



const chatButtonText = computed(() => {
  if (props.type === 'received') {
    return t(
      props.isOfferOpen
        ? 'my-projects.offers-detail.action-buttons.start-talks'
        : 'my-projects.offers-detail.action-buttons.message'
    );
  }
  return t('my-projects.offers-detail.action-buttons.message');
});


return { __sfc: true,props, isNarrow, t, emit, chatButtonText, BCXButton, BCXItemsWithPoints }
}

})